import { createSlice } from "@reduxjs/toolkit";
import { totalNumberOfRegions } from "../../../api/map-action";

const initialState = {
  placesbygoogle: [],
  placesbygoogleForDestination: [],
  sourceInput: undefined,
  sourceInputFromApi: undefined,
  destinationInput: undefined,
  destinationInputFromApi: undefined,
  regions: [],
  fetchedRegions: [],
  totalRegions: undefined,
  regionLoading: false,
  pageCount: 1,
  flatRegionPageCount: 1,
  totalFlatRegions: undefined,
  isLoading: false,

  // trippackage
  isTripPackageSearchLoading: false,
  isTripDestPackageSearchLoading: false,
};

const mapSlice = createSlice({
  name: "map",
  initialState: initialState,
  reducers: {
    setIsLoadingMap: (state, action) => {
      state.isLoading = action.payload.isLoading;
    },
    pageCountIncrease: (state, action) => {
      state.pageCount = state.pageCount + 1;
    },
    flatRegionPageCountIncrease: (state, action) => {
      state.flatRegionPageCount = state.flatRegionPageCount + 1;
    },
    flatRegionPageCountDecrease: (state, action) => {
      if (state.flatRegionPageCount < 2) {
        state.flatRegionPageCount = 1;
      } else {
        state.flatRegionPageCount = state.flatRegionPageCount - 1;
      }
    },
    pageCountDecrease: (state, action) => {
      if (state.pageCount < 2) {
        state.pageCount = 1;
      } else {
        state.pageCount = state.pageCount - 1;
      }
    },
    setRegionLoading: (state, action) => {
      state.regionLoading = action.payload.regionLoading;
    },
    setSourceInput: (state, action) => {
      state.sourceInputFromApi = action.payload.sourceInputFromApi;
      state.placesbygoogle = [];
    },
    changeSourceInput: (state, action) => {
      state.sourceInput = action.payload.sourceInput;
    },
    clearSourceInput: (state) => {
      state.sourceInput = "";
      state.sourceInputFromApi = undefined;
    },
    setDestinationInput: (state, action) => {
      state.destinationInputFromApi = action.payload.destinationInputFromApi;
      state.placesbygoogleForDestination = [];
    },
    changeDestinationInput: (state, action) => {
      state.destinationInput = action.payload.destinationInput;
    },
    clearDestinationInput: (state) => {
      state.destinationInput = "";
      state.destinationInputFromApi = undefined;
    },
    getPlacesFromGoogle: (state, action) => {
      state.placesbygoogle = action.payload.placesbygoogle;
    },
    getPlacesFromGoogleForDestination: (state, action) => {
      state.placesbygoogleForDestination =
        action.payload.placesbygoogleForDestination;
    },
    getRegions: (state, action) => {
      state.regions = action.payload.regions;
    },
    geTotalRegions: (state, action) => {
      state.totalRegions = action.payload.totalRegions;
    },
    getTotalFlatRegions: (state, action) => {
      state.totalFlatRegions = action.payload.totalFlatRegions;
    },

    // ----------------- trippackage -----------------
    setIsTripPackageSearchLoading: (state, action) => {
      state.isTripPackageSearchLoading =
        action.payload.isTripPackageSearchLoading;
    },
    setIsTripDestPackageSearchLoading: (state, action) => {
      state.isTripDestPackageSearchLoading =
        action.payload.isTripDestPackageSearchLoading;
    },
  },
});

export const {
  getPlacesFromGoogle,
  setSourceInput,
  clearSourceInput,
  changeSourceInput,
  getPlacesFromGoogleForDestination,
  setDestinationInput,
  clearDestinationInput,
  changeDestinationInput,
  getRegions,
  geTotalRegions,
  setRegionLoading,
  pageCountIncrease,
  pageCountDecrease,
  setIsLoadingMap,
  flatRegionPageCountIncrease,
  flatRegionPageCountDecrease,
  getTotalFlatRegions,
  setIsTripPackageSearchLoading,
  setIsTripDestPackageSearchLoading,
} = mapSlice.actions;

export const mapSliceReducer = mapSlice.reducer;
